import { render, staticRenderFns } from "./pendingEdit.vue?vue&type=template&id=63aa861c&scoped=true&"
import script from "./pendingEdit.vue?vue&type=script&lang=js&"
export * from "./pendingEdit.vue?vue&type=script&lang=js&"
import style0 from "./pendingEdit.vue?vue&type=style&index=0&id=63aa861c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa861c",
  null
  
)

export default component.exports